import { createSearchParams, useNavigate } from "react-router-dom";
import RoutesConst from "@consts/RoutesConst";
import GeneralStrings from "@strings/GeneralStrings.json";
import { getExcerpt, getReadTime } from "@utilities/BlogHelper";
import "./BlogPostCard.scss";

const formatDate = (dateStr: string): string => {
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d
    .toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      timeZone: "UTC",
    })
    .toUpperCase();
};

const padNumber = (n: number): string => `N° ${String(n).padStart(2, "0")}`;

const BlogPostCard = ({
  post,
  postNumber,
  showViewButton = true,
}: {
  post: BlogPost;
  postNumber?: number;
  showViewButton?: boolean;
}) => {
  const navigate = useNavigate();

  if (!post) return null;

  const handleReadEntry = () => {
    navigate({
      pathname: RoutesConst.BLOG.VIEW_POST,
      search: createSearchParams({ id: post.id }).toString(),
    });
  };

  return (
    <div className="blog-post-card">
      <div className="card-image-wrap">
        {postNumber !== undefined && (
          <span className="card-number">{padNumber(postNumber)}</span>
        )}
        <img
          src={post.imgLoc}
          alt={post.title}
          loading="lazy"
          className="card-img"
        />
      </div>

      <h3 className="card-title">{post.title}</h3>
      <p className="card-excerpt">{getExcerpt(post.subtitle)}</p>

      <p className="card-meta">
        <span>{formatDate(post.date)}</span>
        <span className="meta-dot">·</span>
        <span>{getReadTime(post.content)} {GeneralStrings.blog.min}</span>
      </p>

      {showViewButton && (
        <button className="card-read-link" onClick={handleReadEntry}>
          {GeneralStrings.blog.readEntry}
        </button>
      )}

      <hr className="card-divider" />
    </div>
  );
};

export default BlogPostCard;
